import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { ItinerariesService, ProfileService } from 'core/services';

export const ItinerariesResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  itinerariesService: ItinerariesService = inject(ItinerariesService),
  profileService: ProfileService = inject(ProfileService)
): Promise<any> => {
  return new Promise((resolve) => {
    const group = route.parent.data.group;
    const clientId =
      route.paramMap.get('clientId') ||
      route.queryParamMap.get('clientId') ||
      profileService.getFixedClientId() ||
      (group && group.clientId);
    const lang = profileService.getLang();

    if (clientId) {
      resolve(itinerariesService.getAccountItinerariesByClientId(clientId, lang));
    } else {
      resolve(itinerariesService.getAccountItineraries(lang));
    }
  });
};
